export default __webpack_public_path__ + "static/media/last8.3faefba5.jpg";